import "../Css/Download_pdf.css";
import Godrej_Logo from "../../../../icons/Godrej_Logo.png";
const TITLES = {
  WPQ: "Welder/Welding Operator Performance Qualifications (WPQ/WOPQ)",
  WPQTTS: "Welder/Welding Operator Performance Qualifications (WPQ/WOPQ)",
  PQR: "Procedure Qualification Record (PQR)",
  WPS: "Welding Procedure Specification",
};
const containerStyle = { paddingTop: "15px", position: "relative" };
const logoContainerStyle = {
  display: "flex",
  width: "70%",
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
};
const logoStyle = { width: "70px", height: "25px", paddingBottom: "5px" };
const Groove_pdf_header_common = ({ from }) => {
  const title = TITLES[from];
  const headertitle = from === "WPQ" ? "WPQGOpageTitle" : "WPSpageHeaderTitle";
  return (
    <header>
      {" "}
      <div className="fontGE" style={containerStyle}>
        {" "}
        <table className="WPStablenoborder" style={containerStyle}>
          {" "}
          <tbody>
            {" "}
            <tr>
              {" "}
              <td rowSpan={3} style={{ width: "30%", verticalAlign: "middle" }}>
                {" "}
                <div style={logoContainerStyle}>
                  {" "}
                  <img
                    src={Godrej_Logo}
                    alt="Godrej Logo"
                    style={logoStyle}
                  />{" "}
                </div>{" "}
              </td>{" "}
              <td className={headertitle}>{title}</td>{" "}
            </tr>{" "}
          </tbody>{" "}
        </table>{" "}
      </div>{" "}
    </header>
  );
};
export default Groove_pdf_header_common;
